export function getEquivalence(emissions: number) {
  const co2PerKm = 0.1652 // cf http://www.e-covoiturage.ch/index.php/fr/aide-a-outils/calculateur-de-co2
  const geneveLausanne = 62 * 2
  // How many trips from Geneve to Lausanne
  const intDivision = Math.trunc(emissions / (geneveLausanne * co2PerKm))

  if (intDivision > 1) {
    return (
      ', soit plus que ' +
      intDivision +
      ' allers-retours de Lausanne à Genève en voiture (' +
      intDivision * geneveLausanne +
      ' kilomètres au total)'
    )
  } else if (intDivision === 1) {
    return (
      ', soit plus qu’un aller-retour de Lausanne à Genève en voiture (' +
      geneveLausanne +
      ' kilomètres)**'
    )
  } else {
    return ''
  }
}
